// extracted by mini-css-extract-plugin
export default {"projectLinkWrapper":"projectLinkWrapper--Rsuoz"};